function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('p',[_vm._v("Business oriented web app that facilitates easier trading of in-game commodities. Comes with intuitive trading UI/UX and a plethora of statistics and detailed information. Django-rest-framework, reactjs, redux, styled-components.")])])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"name":"TradinGUI","tech":["React","Redux","Django REST","styled-components"],"cover":"tradingui.png","github":"https://github.com/pizzadudez/TradinGUI","hosted":"https://tradingui.vladalbert.com"},
    
      body: "Business oriented web app that facilitates easier trading of in-game commodities. Comes with intuitive trading UI/UX and a plethora of statistics and detailed information. Django-rest-framework, reactjs, redux, styled-components.\r\n",
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }